<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
      <!-- <div class="row">
        <div class="col">
          <div class="d-flex align-items-center justify-content-end">
            <date-picker class="date-picker" v-model="time3" range></date-picker>
            <button class="btn glob-btn">Search</button>
          </div>
        </div>
      </div> -->

    <b-popover target="popover-target-1" triggers="hover" placement="Right">
      <div>
      <b>Description</b>
       <p class="mb-0">
       "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
         Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
          nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in"
        </p>
        </div>
      </b-popover>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-8">
          <div class="p-3 border-right">
             <h5><i class="bi bi-info-circle-fill text-primary pop-info-icon" id="popover-target-1"></i>TsupitHero's Corner</h5>
            <h2 class="main-title">{{ TsupitHerosCorner.title }}</h2>
            <table class="table table-bordered stock-reco-card">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="4" class="text-center">Stock Recommendation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    Stock
                    <h4 class="stock-label">
                      {{ TsupitHerosCorner.stockRecommendations.stockSymbol }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Entry Price
                    <h4 class="stock-label">
                      {{ TsupitHerosCorner.stockRecommendations.entryPrice }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Target Price
                    <h4 class="stock-label">
                      {{ TsupitHerosCorner.stockRecommendations.targetPrice }}
                    </h4>
                  </td>
                  <td class="text-center">
                    Potential Upside
                    <h4 class="stock-label">
                      {{ TsupitHerosCorner.stockRecommendations.potentialUpside }}
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="overview">
              <h5 class="sub-title-page">Action Plan</h5>
              <p
                class="text-muted"
                v-html="TsupitHerosCorner.stockRecommendations.article"
              ></p>
              <div class="button-container">
                  <router-link to="/TsupitHeroCorner/Archive"> More Reports </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="p-3">
            <h5 class="sub-title-page">Stock Recommendation</h5>
            <!-- <StockReco /> -->
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col">
          <h5 class="sub-title-page">Stock With Momentum</h5>
          <div class="table-responsive">
            <!-- <table class="table secondary-table table-bordered text-nowrap">
            <thead>
              <tr>
                <th>Stock</th>
                <th>Price</th>
                <th>20 EMA</th>
                <th>50 EMA</th>
                <th>RSI 14</th>
                <th>Value Turnover (10 day avg.)</th>
                <th>Market Cap</th>
                <th>Net Foreign (Past 5 days)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in TsupitHerosCorner.stocksWithMomentum" :key="index">
                <td>{{item.stockSymbol}}</td>
                <td>{{item.price}}</td>
                <td>{{item.emA20}}</td>
                <td>{{item.emA50}}</td>
                <td>{{item.rsI14}}</td>
                <td>{{item.valueTurnover}}</td>
                <td>{{item.marketCap}}</td>
                <td>{{item.netForeign}}</td>
              </tr>
            </tbody>
          </table> -->
          </div>
        </div>
      </div>
      <TradingStrategies v-show="false" />
    </div>
       <Footer />
  </div>
</template>

<script>
import navHeader from "../ResearchPages/NavHeader";
import Footer from "../ResearchPages/Footer";
// import StockReco from "../ResearchPages/TsupitHeroStockReco.vue";
import TradingStrategies from "../ResearchPages/TradingStrategies";
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: {
    navHeader,
    Footer,
    // StockReco,
    TradingStrategies,
  },
  data() {
    return {
      isDataLoaded: false,
      time3: "",
    };
  },
  computed: {
    ...mapState({
      PageContent: (state) => state.philstocksResearch.HomeContent,
      TsupitHerosCorner: (state) => state.philstocksResearch.tsupitHerosCornerContent,
      KapitmansCorner: (state) => state.philstocksResearch.KapitsmanCornerContent,
    }),
  },
  methods: {
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
     ViewReport(data)
      {
            this.$store.dispatch("philstocksResearch/SET_FullReport" , data);

      },

    tsupitHerosCorner() {
      this.$gtag.event("tsupitHerosCorner", { method: "Google" });
    },
    async GetTsupitHeroContent() {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetHomeContent")
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },

  async mounted() {
    this.GetTsupitHeroContent();
  },
};
</script>

<style></style>
